import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IntersectionObserverDirective } from '../../../core/directives/animate-on-visible.directive';

@Component({
  selector: 'app-why-us',
  imports: [RouterLink, IntersectionObserverDirective],
  templateUrl: './why-us.html',
  styleUrl: './why-us.scss',
})
export class WhyUs {

}
